








































import { Component, Vue } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import SpecOutDetailsComponent from '@/components/SpecOuts/SpecOutDetails.vue';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue'
import SpecOutStatus from '@/components/SpecOuts/Display/SpecOutStatus.vue';
import SpecOutStatusEnum from '@/models/SpecOuts/SpecOutStatus';
import SpecOutDto from '@/models/SpecOuts/SpecOutDto';
import SpecOutContactsTab from '@/components/SpecOutContacts/SpecOutContactsTab.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'SpecOut',
  components: { Alert, SpecOutStatus, SpecOutDetails: SpecOutDetailsComponent, SpecOutContactsTab }})

export default class extends GiganautVue {

  specOutStatusEnum = SpecOutStatusEnum;

  async beforeMount() {
    await SpecOutDetailsModule.getSpecOut(this.$route.params.specoutid);
  }

  get currentSpecOut() {
    return SpecOutDetailsModule.currentSpecOut;
  }

  get loading() {
    return SpecOutDetailsModule.loading;
  }

  async sendSpecOut() {
		const options: VuetifyConfirmObject = {
            buttonTrueText: "SEND",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('This will send worker profiles to all contacts. Would you like to send?', options);
        if (result) {
			await SpecOutDetailsModule.sendSpecOut();
        }
	}
}
